// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"170ce95f","834":"dea24262"}[chunkId] + ".chunk.js";
};